import { render, staticRenderFns } from "./CommentTypeSelect.vue?vue&type=template&id=eab4f052&scoped=true"
import script from "./CommentTypeSelect.vue?vue&type=script&lang=ts"
export * from "./CommentTypeSelect.vue?vue&type=script&lang=ts"
import style0 from "./CommentTypeSelect.vue?vue&type=style&index=0&id=eab4f052&lang=sass&scoped=true"
import style1 from "./CommentTypeSelect.vue?vue&type=style&index=1&id=eab4f052&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab4f052",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eab4f052')) {
      api.createRecord('eab4f052', component.options)
    } else {
      api.reload('eab4f052', component.options)
    }
    module.hot.accept("./CommentTypeSelect.vue?vue&type=template&id=eab4f052&scoped=true", function () {
      api.rerender('eab4f052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Comments/CommentTypeSelect.vue"
export default component.exports